import { ComponentProps } from "react";
import { FormattedMessage } from "react-intl";

import { AssessmentCopyVariants } from "./assessment-copy.types";
import { pickAssessmentCopyVariant } from "./assessment-copy.utils";
import { useIsSurvey } from "./useIsSurvey.hook";

type MessageValues = ComponentProps<typeof FormattedMessage>["values"];

/**
 * @param {AssessmentCopyVariants} variants - the assessment- and survey-worded messages for one string
 * @param {MessageValues} values - ICU values, forwarded to FormattedMessage
 * @returns {ReactElement} the variant matching the survey flag of the surrounding assessment
 */
export function AssessmentCopy({ variants, values }: { variants: AssessmentCopyVariants; values?: MessageValues }) {
  const isSurvey = useIsSurvey();

  return <FormattedMessage {...pickAssessmentCopyVariant({ variants, isSurvey })} values={values} />;
}
